import { PageHeader } from '@/components/layout/PageHeader'

export function AgentsActionsPage() {
  return (
    <div className="flex flex-col gap-8 p-8">
      <PageHeader title="Configure and manage agent capabilities and integrations" />
    </div>
  )
}
